<script setup>
import TitleTwo from '@/components/title-des/titleTwo.vue'

const brainData = [
  {
    title: '01/',
    title2: '全量产业数据',
    data: [
      { count: '6200万+', name: '在营企业数据' },
      { count: '3807万+', name: '专利技术数据' },
      { count: '50000+', name: '特色园区数据' },
      { count: '500万+', name: '高管籍贯数据' },
      { count: '100万+', name: '高校校友数据' },
      { count: '1200万+', name: '客户关系数据' },
      { count: '10000+', name: '投资机构数据' },
      { count: '100万+', name: '产业人才数据' },
      { count: '30000+', name: '早小项目数据' },
    ],
  },
  {
    title: '02/',
    title2: '专属区域数据',
    data: [
      {
        icon: 'https://static.idicc.cn/cdn/official/H5/attract_data02_01.png',
        name: '企业基础数据',
      },
      {
        icon: 'https://static.idicc.cn/cdn/official/H5/attract_data02_02.png',
        name: '企业客户关系',
      },
      {
        icon: 'https://static.idicc.cn/cdn/official/H5/attract_data02_03.png',
        name: '乡贤企业数据',
      },
      {
        icon: 'https://static.idicc.cn/cdn/official/H5/attract_data02_04.png',
        name: '校友企业数据',
      },
      {
        icon: 'https://static.idicc.cn/cdn/official/H5/attract_data02_05.png',
        name: '区域产业政策',
      },
      {
        icon: 'https://static.idicc.cn/cdn/official/H5/attract_data02_06.png',
        name: '区域产业规划',
      },
      {
        icon: 'https://static.idicc.cn/cdn/official/H5/attract_data02_07.png',
        name: '区域资源禀赋',
      },
      {
        icon: 'https://static.idicc.cn/cdn/official/H5/attract_data02_08.png',
        name: '区域载体信息',
      },
    ],
  },
  {
    title: '03/',
    title2: '六大招商模型',
    data: [
      {
        t1: '亲缘招商',
        t2: '利用乡情、血缘、校友等人际关系网络，吸引在外发展的企业家、投资者或专业人才返乡投资创业。便于地方政府吸引“游子归巢”或校友回馈母校所在地区。',
      },
      {
        t1: '资本招商',
        t2: '通过设立产业基金、股权投资、融资担保等方式，直接参与或支持企业发展，以资本为纽带吸引项目落地。常见形式包括与投资机构合作、参股优质企业、提供低息贷款等。',
      },
      {
        t1: '链式招商',
        t2: '根据区域内主导产业或龙头企业，针对产业链的薄弱环节或关键配套进行定向招商，以完善产业链、提升集群竞争力。例如通过引进上下游企业，形成从原材料到终端产品的完整产业生态。',
      },
      {
        t1: '人才招商',
        t2: '以引进高端人才或团队为核心，通过为其提供科研经费、平台建设、配套政策等支持，吸引人才携带技术、项目或资本落地，从而带动相关产业和创新资源集聚。',
      },
      {
        t1: '舆情招商',
        t2: '通过积极塑造和传播地区的正面形象（如营商环境、政策优势、产业特色等），借助媒体宣传、网络舆情引导、口碑营销等方式，提升区域知名度与吸引力，间接吸引投资关注。',
      },
      {
        t1: '先机招商',
        t2: '在新技术、新业态或新政策出现的早期阶段，快速布局抢占发展先机。例如提前规划未来产业赛道（如人工智能、新能源），通过提前出台专项政策、建设配套设施等方式，吸引首批企业入驻形成先发优势。',
      },
    ],
  },
  {
    title: '04/',
    title2: '每日优企智推',
    data: 'https://static.idicc.cn/cdn/official/H5/attract_data04.png',
  },
  {
    title: '05/',
    title2: '哒达助招',
    data: 'https://static.idicc.cn/cdn/official/H5/attract_data05.png',
  },
  {
    title: '06/',
    title2: '哒达臻选',
    data: 'https://static.idicc.cn/cdn/official/H5/attract_data06.png',
  },
]
</script>

<template>
  <div class="brainPart w-full">
    <div class="text-[28px] text-[#666] text-left leading-[40px] mt-4 px-4">
      基于IDICC全量产业数据底座，生成需求属地产业链画像和地图，全面深度了解属地产业链情况;实时追踪属地目标产业链的所有企业，与属地画像匹配形成我们的分析系统-七大招商模型，为属地招商挑选匹配企业最后根据企业招商线索，精准四配IDICC线下招商顾问，为需求招商做到最后一百米的精准招商触达及对接。
    </div>
    <TitleTwo
      title="哒达招商AI智能体"
      top="32px"
      bottom="16px"
      sub-title="数据支撑决策 · 平台赋能招商"
    />
    <div class="bg-left-right">
      <div
        class="w-full text-[28px] font-bold flex flex-col justify-center gap-[32px] pt-4"
      >
        <div
          v-for="brain in brainData"
          :key="brain.title"
          class="relative px-[32px]"
        >
          <div class="flex items-center justify-center">
            <span class="text-[40px] font-bold text-[#DBE0F0]"> {{ brain.title }}</span>
            <span class="text-[28px] font-bold text-[#1741CD]"> {{ brain.title2 }}</span>
          </div>
          <div class="bgCard">
            <div v-if="brain.title === '01/'" class="flex items-center justify-between flex-wrap gap-[22px]">
              <div
                v-for="card in brain.data"
                :key="card.t1"
                class="brainCards flex flex-col items-center justify-center"
              >
                <div class="text-[36px] text-[#333333] font-bold">
                  {{ card.count }}
                </div>
                <div class="text-[24px] text-[#666666]">
                  {{ card.name }}
                </div>
              </div>
            </div>
            <div v-if="brain.title === '02/'" class="flex items-center justify-between flex-wrap gap-[22px]">
              <div
                v-for="card in brain.data"
                :key="card.t1"
                class="w-[300px] h-[136px] flex flex-col items-center justify-center rounded-[8px] bg-white "
              >
                <img :src="card.icon" class="w-[64px] h-[64px]" alt="">
                <div class="text-[28px] text-[#333]">
                  {{ card.name }}
                </div>
              </div>
            </div>
            <div v-if="brain.title === '03/'" class="flex items-center justify-between flex-col gap-[22px]">
              <div
                v-for="card in brain.data"
                :key="card.t1"
                class="w-full flex flex-col justify-center rounded-[8px] bg-white px-[24px] py-[24px]"
              >
                <div class="text-[28px] text-[#333] font-bold">
                  {{ card.t1 }}
                </div>
                <div class="bg-[#1741CD] w-[112px] h-[2px] my-2" />
                <div class="text-[28px] text-[#666666] leading-[40px]">
                  {{ card.t2 }}
                </div>
              </div>
            </div>
            <div class="flex items-center justify-center">
              <img :src="brain.data" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.brainPart {
  .bg-left-right {
    width: 100%;
  }
}
.scrollBar {
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}
.bgCard{
  width: 100%;
  background: linear-gradient( 175deg, #1741CD 0%, #E0E6F6 100%);
  border-radius: 16px;
  padding: 32px;
  box-sizing: border-box;
}
.brainCards{
    width: 300px;
    height: 120px;
    background: center / contain no-repeat
      url("https://static.idicc.cn/cdn/official/H5/attract_data01_bg.png");
    background-size: 100%;
}
</style>
